"use strict";

var ScenarioFilter = function () {
  const StructuralBmpFilters = require("../bmpFcsG2/structuralBmpFilters");

  var filterResourceDataHandler = function (unfilteredData, filters, loadingScreen, smartFilters) {
    const filteredData = ResourceFilters.spatialFilters(unfilteredData, filters);
    return filterOffline(filteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
  };

  var getFilterConfigs = function () {
    return {
      drainsToSpatialGroupingId: "monitoringName",
      drainsToAssesmentArea: ["assessmentMonitoringName", "array"],
      highwayName: "highwayName",
      drainsToRw: "drainsToRw",
      drainsToC: "drainsToC",
      catchmentName: "catchmentName",
      subGroups: "groupId",
      scenario: "scenario",
      phase: "phase",
      sbmpCategory: StructuralBmpFilters.getPassCategoryFilter("bmpSortOrder"),
      types: "bmpSortOrder",
      analysisReady: "analysisReady",
      otherFilters: (datum, filters) => {
        return ResourceFilters.passSearchStringFilter(datum, filters, ["assetId"]);
      },
    };
  };

  return {
    filterResourceDataHandler,
    getFilterConfigs,
  };
};

module.exports = ScenarioFilter();
const ResourceFilters = require("./resourceFilters");
